import { InjectionToken } from '@angular/core';
import { defaultEditorColors, EDITOR_BLANK_COLOR, TUI_DEFAULT_LINK_OPTIONS, tuiDefaultFontOptionsHandler } from '@taiga-ui/addon-editor/constants';
import { identity, ReplaySubject } from 'rxjs';
import { tuiExtractI18n } from '@taiga-ui/i18n';
import { tuiTypedFromEvent } from '@taiga-ui/cdk';
import { map } from 'rxjs/operators';

/**
 * Extensions for editor
 */
const TUI_EDITOR_EXTENSIONS = new InjectionToken(`[TUI_EDITOR_EXTENSIONS]`);
/**
 * lazy extensions
 */
const LAZY_EDITOR_EXTENSIONS = new InjectionToken(`[LAZY_EDITOR_EXTENSIONS]`);

const TUI_EDITOR_DEFAULT_OPTIONS = {
    translate: `no`,
    spellcheck: false,
    colors: defaultEditorColors,
    blankColor: EDITOR_BLANK_COLOR,
    linkOptions: TUI_DEFAULT_LINK_OPTIONS,
    fontOptions: tuiDefaultFontOptionsHandler,
};
/**
 * Default Editor colors
 */
const TUI_EDITOR_OPTIONS = new InjectionToken(`[TUI_EDITOR_OPTIONS]`, {
    factory: () => TUI_EDITOR_DEFAULT_OPTIONS,
});
function tuiEditorOptionsProvider(options) {
    return {
        provide: TUI_EDITOR_OPTIONS,
        useValue: Object.assign(Object.assign({}, TUI_EDITOR_DEFAULT_OPTIONS), options),
    };
}

/**
 * @deprecated: drop in v4.0
 * use {@link TUI_EDITOR_VALUE_TRANSFORMER}
 */
const TUI_EDITOR_CONTENT_PROCESSOR = new InjectionToken(`[TUI_EDITOR_CONTENT_PROCESSOR]`, {
    factory: () => identity,
});

const TUI_EDITOR_VALUE_TRANSFORMER = new InjectionToken(`[TUI_EDITOR_VALUE_TRANSFORMER]`);

/**
 * files loader options
 */
const TUI_ATTACH_FILES_OPTIONS = new InjectionToken(`[TUI_ATTACH_FILES_OPTIONS]`, {
    factory: () => ({ accept: `*/*`, multiple: true }),
});
/**
 * files loader handler
 */
const TUI_ATTACH_FILES_LOADER = new InjectionToken(`[TUI_ATTACH_FILES_LOADER]`);

/**
 * tui-color-selector i18n
 */
const TUI_EDITOR_COLOR_SELECTOR_MODE_NAMES = new InjectionToken(`[TUI_EDITOR_COLOR_SELECTOR_MODE_NAMES]`, {
    factory: () => [`Solid color`, `Gradient`],
});
/**
 * tui-editor-toolbar i18n
 */
const TUI_EDITOR_TOOLBAR_TEXTS = new InjectionToken(`[TUI_EDITOR_TOOLBAR_TEXTS]`, {
    factory: tuiExtractI18n(`toolbarTools`),
});
/**
 * tui-editor-toolbar table i18n
 */
const TUI_EDITOR_TABLE_COMMANDS = new InjectionToken(`[TUI_EDITOR_TABLE_COMMANDS]`, {
    factory: tuiExtractI18n(`editorTableCommands`),
});
/**
 * tui-editor-toolbar edit-link i18n
 */
const TUI_EDITOR_LINK_TEXTS = new InjectionToken(`[TUI_EDITOR_LINK_TEXTS]`, {
    factory: tuiExtractI18n(`editorEditLink`),
});
/**
 * tui-editor-toolbar codes options
 */
const TUI_EDITOR_CODE_OPTIONS = new InjectionToken(`[TUI_EDITOR_CODE_OPTIONS]`, {
    factory: tuiExtractI18n(`editorCodeOptions`),
});
/**
 * tui-editor-toolbar font options
 */
const TUI_EDITOR_FONT_OPTIONS = new InjectionToken(`[TUI_EDITOR_FONT_OPTIONS]`, {
    factory: tuiExtractI18n(`editorFontOptions`),
});

/**
 * Image loader handler
 */
const TUI_IMAGE_LOADER = new InjectionToken(`[TUI_IMAGE_LOADER]`, {
    factory: () => file => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        return tuiTypedFromEvent(fileReader, `load`).pipe(map(() => String(fileReader.result)));
    },
});

/**
 * Token for Tiptap Editor
 */
const TIPTAP_EDITOR = new InjectionToken(`[TIPTAP_EDITOR]`);
/**
 * Lazy loaded Editor
 */
const LAZY_TIPTAP_EDITOR = new InjectionToken(`[LAZY_TIPTAP_EDITOR]`, {
    factory: () => {
        const editor$ = new ReplaySubject(1);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        import('@tiptap/core').then(m => editor$.next(m.Editor));
        return editor$;
    },
});
/**
 * The container in which the tip-tap editor is initialized
 */
const INITIALIZATION_TIPTAP_CONTAINER = new InjectionToken(`[INITIALIZATION_TIPTAP_CONTAINER]`);

/**
 * Generated bundle index. Do not edit.
 */

export { INITIALIZATION_TIPTAP_CONTAINER, LAZY_EDITOR_EXTENSIONS, LAZY_TIPTAP_EDITOR, TIPTAP_EDITOR, TUI_ATTACH_FILES_LOADER, TUI_ATTACH_FILES_OPTIONS, TUI_EDITOR_CODE_OPTIONS, TUI_EDITOR_COLOR_SELECTOR_MODE_NAMES, TUI_EDITOR_CONTENT_PROCESSOR, TUI_EDITOR_DEFAULT_OPTIONS, TUI_EDITOR_EXTENSIONS, TUI_EDITOR_FONT_OPTIONS, TUI_EDITOR_LINK_TEXTS, TUI_EDITOR_OPTIONS, TUI_EDITOR_TABLE_COMMANDS, TUI_EDITOR_TOOLBAR_TEXTS, TUI_EDITOR_VALUE_TRANSFORMER, TUI_IMAGE_LOADER, tuiEditorOptionsProvider };
